import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BrokerGroupService, SurveyService } from '@app/services';
import { BrokerGroupLicenseTableConfig } from './broker-group-license.table-config';
@Component({
  selector: 'app-broker-group-add-edit',
  templateUrl: './broker-group-add-edit.component.html',
  styleUrls: ['./broker-group-add-edit.component.scss']
})
export class BrokerGroupAddEditComponent implements OnInit {

  @Output() onDone: any = new EventEmitter();
  @Input() group: any;
  form: any;
  licenseConfig = BrokerGroupLicenseTableConfig.configure()
  surveyList: any[]

  constructor(
    private surveyService: SurveyService,
    private brokerGroupService: BrokerGroupService) { }

  ngOnInit(): void {
    this.form = {
      name: "",
      brokerRates: [],
      clientRates: [],
      discountCode: "",
      surveys: []
    }
    console.log(this.group)
    if (this.group != null) {
      this.form = this.group
      this.form.discountCode = this.group.discountCodes[0]
    }
    this.getSurveyList();
  }

  getSurveyList() {
    this.surveyService.list().subscribe({
      next: (res: any) => {
        this.surveyList = res.data
      }
    })
  }

  onSaveHandler() {
    let sendObj = {
      discountCodes: [this.form.discountCode],
      brokerRates: this.form.brokerRates.map((o: any) => ({
        from: o.from,
        to: o.to,
        rate: Number(o.rate)
      })),
      clientRates: this.form.clientRates.map((o: any) => ({
        from: o.from,
        to: o.to,
        rate: Number(o.rate)
      })),
      name: this.form.name,
      surveys: this.form.surveys
    }

    if(this.group != null) {
      return this.brokerGroupService.update( this.group._id, sendObj).subscribe({
        next: (res: any) => {
          this.onDone.emit(res.data)
        },
        error: (error: any) => { }
      })
    }
    return this.brokerGroupService.add(sendObj).subscribe({
      next: (res: any) => {
        this.onDone.emit(res.data)
      },
      error: (error: any) => { }
    })
  }

}
